// extracted by mini-css-extract-plugin
export default {"tableActionsBar":"table-actions-bar_tableActionsBar__oCAqZ","bulkActions":"table-actions-bar_bulkActions__A+wgK","singularActions":"table-actions-bar_singularActions__ltxhC"};